import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import {
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
   Separator,
   StyledFlex,
   StyledMargin,
} from '@dreryk/react-components';

import { patientTranslationKeys } from '../../translations';
import { PatientUnconfirmedForm } from '../PatientUnconfirmedForm';

import { ExistingPatientForm } from './existingPatientForm/ExistingPatientForm';
import { PatientAssociateModalConfirmButton } from './PatientAssociateModalConfirmButton';
import { PatientAssociateModalSubheadingPortalContainer } from './PatientAssociateModalSubheadingPortal';

type PatientAssociateModalProps = {
   readonly onClose: VoidFunction;
   readonly unconfirmedPatient: Omit<PatientSimple, 'medicalDocumentationCreated'>;
};
export const PatientAssociateModal = (props: PatientAssociateModalProps): JSX.Element => {
   return (
      <Modal
         testId={'patientAssociate'}
         title={patientTranslationKeys.unconfirmed.associateWithExistingFile}
         width={ModalWidth.FULL}
      >
         <StyledFlex direction={'column'}>
            <PatientAssociateModalSubheadingPortalContainer />
            <ExistingPatientForm comparedPatient={props.unconfirmedPatient}>
               {({ patient }) =>
                  patient ? (
                     <StyledMargin top={28}>
                        <Separator />
                        <StyledMargin top={18}>
                           <StyledFlex>
                              <PatientUnconfirmedForm patient={patient} comparedPatient={props.unconfirmedPatient}>
                                 {({ handleSubmit, formState, reset }) => (
                                    <>
                                       <PatientAssociateModalConfirmButton
                                          patientId={patient.id}
                                          unconfirmedPatientId={props.unconfirmedPatient.id}
                                          handleSubmit={handleSubmit}
                                          onSuccess={reset}
                                       />
                                       <ModalCloseButton
                                          onClick={props.onClose}
                                          shouldConfirmExit={formState.isDirty}
                                       />
                                       <ModalCancelButton
                                          onClick={props.onClose}
                                          shouldConfirmExit={formState.isDirty}
                                       />
                                    </>
                                 )}
                              </PatientUnconfirmedForm>
                           </StyledFlex>
                        </StyledMargin>
                     </StyledMargin>
                  ) : (
                     <>
                        <ModalCloseButton onClick={props.onClose} />
                        <ModalCancelButton onClick={props.onClose} />
                        <ModalConfirmButton label={patientTranslationKeys.unconfirmed.close} onClick={props.onClose} />
                     </>
                  )
               }
            </ExistingPatientForm>
         </StyledFlex>
      </Modal>
   );
};
